import Component from 'vue-class-component';
import { Mixins, Prop, Ref } from 'vue-property-decorator';
import { Section } from '@/courses/models/section.model';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';
import { COMPONENT_TYPE } from '@/courses/values/courses.values'
import EdDeckViewerComponent from '../ed-deck-viewer/ed-deck-viewer.component';
import EdDeckEditorComponent from '../ed-deck-editor/ed-deck-editor.component';
import ToolService from '@/providers/tools';

@Component({
  name: 'ed-deck-viewer-container',
  components: {
    EdDeckViewer: () => import(/* EdDeckViewerContainer */'../ed-deck-viewer/ed-deck-viewer.component.vue'),
    EdDeckEditor: () => import(/* EdDeckEditor */'../ed-deck-editor/ed-deck-editor.component.vue'),
  }
})
export default class EdDeckViewerContainerComponent extends Mixins(CourseToolsMixin) {
  @Prop() courseId: number;
  @Prop() selectedCard: number;

  @Ref('deckViewer') deckViewer: EdDeckViewerComponent;
  @Ref('deckEditor') deckEditor: EdDeckEditorComponent;

  isMobile = false;

  get course() {
    return this.getCourseFromStore({ 
      courseId: this.courseId,
    });
  }

  get deck(): Section {
    return this.course.component.section;
  }

  get cards(): Section[] {
    return this.deck?.sections;
  }

  get cardSelected(): number {
    return this.course.component.cardSelected;
  }

  get editionMode() {
    return this.course.component.edition;
  }

  openDeckEditor(card = null) {
    setTimeout(() => {
      this.deckEditor?.loadCard(card);
    }, 200);
  }

  onCardSelectedChanged(cardSelected: Section) {
    this.$edEventBus.$emit(COURSES_EVENTS.OBJECT_SELECTED, {
      sectionId: cardSelected ? cardSelected.id : null,
      courseId: this.courseId,
    });
  }

  onGoToSelectCard(card: Section) {
    this.deckViewer?.onCardSelected({
      card,
      isFlipped: false,
    });
  }

  onDeckCardRemoved() {
    this.$Courses.$emit(COURSES_EVENTS.OPEN_DECK_EDITOR);
  }
  
  onDeckMoveDown() {
    if(this.cardSelected) {
      const index = this.cards.findIndex(c => c.id === this.cardSelected);
      const nextCard = this.cards[index >= (this.cards.length - 1) ? (this.cards.length - 1) : index + 1];
      const parentSection = SectionsProvider.getDeckLibraryByID(
        this.course.deckLibrary.sections,
        this.cards[index].parentId
      );

      this.setCard(nextCard, parentSection);
    }
  }
  
  onDeckMoveUp() {
    if (this.cardSelected) {
      const index = this.cards.findIndex(c => c.id === this.cardSelected);
      const prevCard = this.cards[index === 0 ? 0 : index - 1];
      const parentSection = SectionsProvider.getDeckLibraryByID(
        this.course.deckLibrary.sections,
        this.cards[index].parentId
      );

      this.setCard(prevCard, parentSection);
    }
  }

  onChangeCardSelected(card: Section) {
    const index = this.cards.findIndex(c => c.id === card.id);
    const cardSelected = this.cards[index === 0 ? 0 : index];
    const parentSection = SectionsProvider.getDeckLibraryByID(
      this.course.deckLibrary.sections,
      this.cards[index].parentId
    );

    this.setCard(cardSelected, parentSection);
  }

  setCard(card: Section, deck: Section) {
    this.$Courses.Store.setComponentSelected({
      courseId: this.courseId,
      classId: this.course.classId,
      componentInfo: { 
        name: COMPONENT_TYPE.DECK_VIEWER.code,
        section: deck,
        edition: true,
        cardSelected: card.id
      } 
    })
    this.$edEventBus.$emit(COURSES_EVENTS.OBJECT_SELECTED, {
      sectionId: card.id,
      courseId: this.courseId,
      classId: this.course.classId,
    });
    this.$Courses.$emit(COURSES_EVENTS.OPEN_DECK_EDITOR, card);
  }

  created() {
    this.$Courses.$on(COURSES_EVENTS.OPEN_DECK_EDITOR, this.openDeckEditor);
    this.$Courses.$on(COURSES_EVENTS.SELECT_CARD, this.onGoToSelectCard);
    this.$Courses.$on(COURSES_EVENTS.DECK_CARD_REMOVED, this.onDeckCardRemoved);
    this.$edEventBus.$on(COURSES_EVENTS.DECK_MOVE_DOWN, this.onDeckMoveDown);
    this.$edEventBus.$on(COURSES_EVENTS.DECK_MOVE_UP, this.onDeckMoveUp);
  }
  
  mounted() {
    this.isMobile = ToolService.getIsMobileDevice();
  }
  
  destroyed() {
    this.$Courses.$off(COURSES_EVENTS.OPEN_DECK_EDITOR);
    this.$Courses.$off(COURSES_EVENTS.SELECT_CARD);
    this.$Courses.$off(COURSES_EVENTS.DECK_CARD_REMOVED);
    this.$edEventBus.$off(COURSES_EVENTS.DECK_MOVE_DOWN);
    this.$edEventBus.$off(COURSES_EVENTS.DECK_MOVE_UP);
  }
}